import { makeStyles } from "tss-react/mui";
import { MiBadge } from "@miplatform/components";

export const AttemptNumberBadge = ({ attemptNumber }) => {
  const { classes, theme } = useStyles();

  return (
    <MiBadge
      className={classes.badge}
      text={`Attempt #${attemptNumber}`}
      fontSize={theme.fontSize.xsmall}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  badge: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.orange.main,
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.orange.dark}`,
    height: theme.spacing(4.5),
    borderRadius: theme.spacing(0.5),
    whiteSpace: "nowrap",
  },
}));
